function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from 'react';
import { ChevronDownIconSmall, ExternalLinkIconSmall } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
var Logo = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-agent-recommendations/static/rma-logo_072ab9ea.svg";
import * as styles from './footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ShowMoreFewerButton = _ref => {
  var displayedReviews = _ref.displayedReviews,
    totalReviews = _ref.totalReviews,
    disableButton = _ref.disableButton,
    hideButton = _ref.hideButton,
    onButtonClick = _ref.onButtonClick,
    className = _ref.className;
  return ___EmotionJSX(Fragment, null, totalReviews > displayedReviews && !hideButton && ___EmotionJSX(Button, {
    className: className,
    appearance: "outline",
    iconPosition: "right",
    icon: ___EmotionJSX(ChevronDownIconSmall, null),
    onClick: onButtonClick,
    disabled: disableButton
  }, "Load more reviews"));
};
var Footer = _ref2 => {
  var displayedReviews = _ref2.displayedReviews,
    totalReviews = _ref2.totalReviews,
    url = _ref2.url,
    _ref2$disableButton = _ref2.disableButton,
    disableButton = _ref2$disableButton === void 0 ? false : _ref2$disableButton,
    _ref2$hideButton = _ref2.hideButton,
    hideButton = _ref2$hideButton === void 0 ? false : _ref2$hideButton,
    onButtonClick = _ref2.onButtonClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var openReviewProfile = () => {
    sendEvent('open-review-profile');
    var win = window.open(url, '_blank');
    if (win) {
      win.opener = null;
    }
  };
  var buttonProps = {
    displayedReviews,
    totalReviews,
    disableButton,
    hideButton,
    onButtonClick
  };
  return ___EmotionJSX("div", {
    css: styles.footer
  }, ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.countPlug
  }, ___EmotionJSX("div", {
    css: styles.count
  }, displayedReviews, " of ", totalReviews, " reviews"), ___EmotionJSX("div", {
    css: styles.plug
  }, ___EmotionJSX("div", {
    css: styles.plugText
  }, "Recommendations provided by"), ___EmotionJSX("img", {
    css: styles.logo,
    alt: "",
    src: Logo
  })), ___EmotionJSX(ShowMoreFewerButton, _extends({
    css: styles.buttonMobile
  }, buttonProps))), url && ___EmotionJSX(Button, {
    iconPosition: "right",
    appearance: "ghost",
    icon: ___EmotionJSX(ExternalLinkIconSmall, null),
    onClick: openReviewProfile
  }, "View all reviews on Rate My Agent")), ___EmotionJSX(ShowMoreFewerButton, _extends({
    css: styles.button
  }, buttonProps)));
};
export { Footer };